import type { ConfigRequest } from '@pba/utils';
import { type ApiClientResponse, type PaginationData, nodeApiClient, nodeApiRoutes } from 'common/services';
import type { MedicalGroupListDataObject } from 'models/service';

export type MedicalGroupsDataObjectWithPagination = PaginationData<MedicalGroupListDataObject>;

type MedicalGroupsRequestParams = {
  _id?: { $in?: string[] };
  $limit?: number;
  $search?: string;
  $skip?: number;
  $sort?: {
    createdAt?: number;
    name?: number;
  };
  createdAt?:
    | {
        $gte?: Date;
        $lte?: Date;
      }
    | Date;
};

export const getMedicalGroups = async ({ config: { params } }: ConfigRequest<MedicalGroupsRequestParams>) =>
  nodeApiClient.get<MedicalGroupsDataObjectWithPagination, ApiClientResponse<MedicalGroupsDataObjectWithPagination>>(
    nodeApiRoutes.medicalGroups.find,
    { params },
  );
